import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { AllowListMember } from 'src/features/parkingManagement/types/allowList';

export type MutationFnType = typeof mutationFn;

const RESOURCE = '/parkings/:parkingId/allow-list/:listId/allow-list-member/';

export type AllowListMemberFormSchemaValues = z.infer<typeof allowListMemberFormSchema>;
export const allowListMemberFormSchema = z.object({
    identifier: z.string().min(1),
    name: z.string().min(1),
    email: z.string().email().nullish(),
    group_name: z.string().nullish(),
});

export interface DTO extends AllowListMemberFormSchemaValues {
    parkingId: string;
    listId: string;
}

const mutationFn = ({ parkingId, listId, ...data }: DTO): Promise<AllowListMember> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, listId }), data);
};

interface UseCreateAdditionalServicesOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}

export const useMutationHook = (options: UseCreateAdditionalServicesOptions) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateAllowListMember };
